import { Component, OnInit  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ConfirmResetPasswordRequest } from '../../models/account/confirmResetPasswordRequest';

import { AccountService } from '../../services/account/account.service';
import { HelperService } from '../../services/common/helper.service';
import { TranslationService } from '../../services/common/translation.service';

@Component({
    selector: 'confirm-reset-password',
    template: require('./../../templates/account/confirmResetPasswordForm.component.html'),
    providers: [AccountService, HelperService, TranslationService]
})
export class ConfirmResetPasswordFormComponent implements OnInit {
    linkId = '';
    username = '';
    isLinkValid = false;
    loaded = false;
    resetRequestConfirmed = false;
    confirmed = false;
    isSuccess = false;

    formBack = '';
    formOops = '';
    formUsername = '';
    resetFormDescription1 = '';
    resetFormPageTitle = '';
    resetFormLinkInvalid = '';
    resetFormConfirmReset = '';
    formSuccess = '';
    resetFormSuccess = '';
    resetFormResetFail = '';

    resetRequest: ConfirmResetPasswordRequest = {
        username: '',
        linkId: '',
        culture: ''
    }

    constructor(private route: ActivatedRoute, private router: Router, private accountService: AccountService, private helperService: HelperService,
        private translationService: TranslationService) {
    }

    ngOnInit() {
        this.initTranslations();
        this.linkId = this.route.snapshot.queryParams.linkId;
        this.validateResetLink();
    }

    initTranslations() {
        this.translationService.translate('form.back', 'Back', (data) => this.formBack = data);
        this.translationService.translate('form.username', 'Username', (data) => this.formUsername = data);
        this.translationService.translate('form.oops', 'Oops!', (data) => this.formOops = data);
        this.translationService.translate('confirmResetForm.pageTitle', 'Confirm Reset Password', (data) => this.resetFormPageTitle = data);
        this.translationService.translate('resetForm.description1', 'Reset of password requested for username:', (data) => this.resetFormDescription1 = data);
        this.translationService.translate('resetForm.linkInvalid', 'The link used is either expired or invalid, if you need to reset password please request it again', (data) => this.resetFormLinkInvalid = data);
        this.translationService.translate('resetForm.confirmReset', 'Confirm', (data) => this.resetFormConfirmReset = data);
        this.translationService.translate('form.success', 'Success!', (data) => this.formSuccess = data);
        this.translationService.translate('resetForm.success', 'Check you email for further instructions', (data) => this.resetFormSuccess = data);
        this.translationService.translate('resetForm.resetFail', 'Error came up while requesting reset of password, either user does not exist or we had a connection problem. Please try again.', (data) => this.resetFormResetFail = data);
    }

    cancel() {
        this.confirmed = false;
        this.isSuccess = false;
        this.router.navigate(['login'], { queryParams: { redirectUrl: this.route.snapshot.queryParams.redirectUrl } });
    }

    validateResetLink() {
        var res = this.accountService.validateResetLink(this.linkId);
        res.subscribe(response => {
            if (response.success) {
                this.isLinkValid = response.data.isValid;
                this.username = response.data.username;
            }

            this.loaded = true;
        });
    }

    confirmResetPassword() {
        this.loaded = false;
        this.resetRequest.username = this.username;
        this.resetRequest.linkId = this.linkId;
        this.resetRequest.culture = TranslationService.currentCulture.code;

        var result = this.accountService.confirmResetPassword(this.resetRequest);
        result.subscribe(response => {

            if (response.success) {
                this.isSuccess = true;
            }
            else {
                this.validateResetLink();
            }

            this.confirmed = true;
            this.loaded = true;
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components/account/confirmResetPasswordForm.component.ts